"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderSummaryDetails = void 0;
const React = require("react");
const SlimSection_1 = require("../../../../../../components/base/structure/SlimSection");
const SalesOrder_1 = require("../../../models/SalesOrder");
const TSalesOrderType_1 = require("../../../types/TSalesOrderType");
const RetailLocationInfo_1 = require("../../RetailLocationCard/RetailLocationInfo");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const SalesOrderSummaryItems_1 = require("../SalesOrderSummaryItems");
const css = (0, cssComposer_1.default)(styles, "SalesOrderSummaryDetails");
const SalesOrderSummaryDetails = ({ salesOrder }) => {
    const { retailLocation: { address: { fullAddress: retailLocationAddress } }, retailLocation, status, type, notes, deliveryAddress: { fullAddress = "" } = {}, displayIdForStatus, displayIdHelpText } = salesOrder;
    const addressHeader = type === TSalesOrderType_1.TSalesOrderType.Delivery
        ? "Delivery address"
        : "Restaurant address";
    const addressText = type === TSalesOrderType_1.TSalesOrderType.Delivery ? fullAddress : retailLocationAddress;
    return (React.createElement(React.Fragment, null,
        React.createElement(SlimSection_1.SlimSection, { className: css("") },
            React.createElement(SlimSection_1.SlimSectionHeader, null,
                React.createElement(SlimSection_1.SlimSectionTitle, null, "Details")),
            React.createElement(SlimSection_1.SlimSectionBody, null,
                React.createElement("div", { className: css("section") },
                    React.createElement("header", { className: css("section_header") }, "Order number"),
                    React.createElement("p", { className: css("section_text") }, displayIdForStatus),
                    status !== SalesOrder_1.TSalesOrderStatus.Pending && (React.createElement("p", { className: css("section_text_extra") }, displayIdHelpText))),
                React.createElement("div", { className: css("section") },
                    React.createElement("header", { className: css("section_header") }, addressHeader),
                    React.createElement("p", { className: css("section_text") }, addressText)),
                notes && (React.createElement("div", { className: css("section") },
                    React.createElement("header", { className: css("section_header") }, "Notes"),
                    React.createElement("p", { className: css("section_text") }, notes))),
                React.createElement(RetailLocationInfo_1.RetailLocationInfo, { retailLocation: retailLocation, orderType: type }))),
        React.createElement(SalesOrderSummaryItems_1.SalesOrderSummaryItems, { salesOrder: salesOrder })));
};
exports.SalesOrderSummaryDetails = SalesOrderSummaryDetails;
//# sourceMappingURL=index.js.map